import ApiCtrl from '@/services/api/abstract/abstract-api.js';

export default {
  /*
      GET /api/v1/admin/conversations
      Filtros: q, search_messages, status, categories[], read, unread_messages, to_manage,
      my_customers, premium, customers[], clavedat[], page
  */
  list(params, config = {}) {
    return ApiCtrl.get('/admin/conversations', Object.assign({ params }, config));
  },
};
